/**
 * 预览子组件-设计师信息组件
 * @author chenqunfeng
 * @since 18/03/28
 */

import './auth-info.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';
import { showRabbitBrandInfo } from 'utils/user';
import { ENTERPRISE, MY_TPL } from 'constants/variable.json5';

import logo from 'assets/images/avatar.png';

class PreviewAuthInfo extends Component {
  static propTypes = {
    data: PropTypes.object,
    newClassName: PropTypes.string,
  };

  // 跳转到设计师页面
  jumpToDesigner() {
    let { designerUrl } = this.props.data;

    if (designerUrl) {
      window.open(designerUrl);
    }
    sendStat(
      'RP_STORE',
      '模版市场',
      '模版弹窗进入设计师主页',
      Stat.ACTION_CLICK,
      {
        id: 'web_mobanmarket_moban_shejishizhuye_click',
      }
    );
  }

  render() {
    const { data, newClassName = '' } = this.props;
    let { designerAvatar, username, designerUrl, category } = data;

    if (!username || username === '匿名') {
      username = '匿名';
    }

    // 企业专区不需要显示
    if (category === ENTERPRISE || category === MY_TPL) {
      return null;
    }

    return (
      <>
        {showRabbitBrandInfo() ? (
          <div className={`s-preview-auth-info ${newClassName}`}>
            <img src={designerAvatar || logo} />
            <span className="s-preview-user-name">{username}</span>
            {designerUrl && (
              <span
                className="s-preview-home"
                onClick={this.jumpToDesigner.bind(this)}>
                设计师主页 &gt;
              </span>
            )}
          </div>
        ) : null}
      </>
    );
  }
}

export default PreviewAuthInfo;
